import { ASCENDING, DESCENDING, SortCriteria } from './Sort.types';

export function asc<T>(compareFn: (a: T, b: T) => number): SortCriteria<T> {
  return { compareFn, direction: ASCENDING };
}

export function desc<T>(compareFn: (a: T, b: T) => number): SortCriteria<T> {
  return { compareFn, direction: DESCENDING };
}

export function multiSort<T>(array: T[], criteria: Array<SortCriteria<T>>): T[] {
  return array.sort((a, b) => {
    for (const { compareFn, direction } of criteria) {
      const result = compareFn(a, b);
      if (result !== 0) {
        return direction === DESCENDING ? -result : result;
      }
    }
    return 0;
  });
}
